<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Serviços para Proprietários';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>
		A Freire Imóveis acompanhando o mercado imobiliário ao longo dos anos facilita sua vida, simplificando a maneira de alugar seu imóvel. Deixe seu imóvel para a Freire Imóveis administrar, e tenha a sua disposição toda a experiência desenvolvida pela empresa ao longo de 35 anos. Nossa equipe é altamente treinada, estando a sua disposição serviços especializados, onde seu imóvel tem todo o acompanhamento e você fica tranquilo.
	</p>
	<p>
		Dentre vários serviços oferecidos podemos destacar:
	</p>
	<ul>
		<li>• Avaliação do imóvel compatível com valor de mercado.</li>
		<li>• Divulgação da locação no site e aplicativo.</li>
		<li>• Feedbacks aos proprietários sobre visitas e clientes interessados.</li>
		<li>• Análise cadastral dos interessados na locação, com consultas aos órgãos de crédito.</li>
		<li>• Elaboração do contrato de locação e vistoria do imóvel.</li>
		<li>• Emissão e controle de cobrança junto ao locatário.</li>
		<li>• Controle e pagamento das despesas.</li>
		<li>• Prestação de contas e informe de rendimento mensal, disponíveis no site da Freire Imóveis.</li>
		<li>• Comunicação anual à Receita Federal de valores dos aluguéis recebidos.</li>
		<li>• Envio de informe de rendimento anual.</li>
		<li>• Cotações para serviços de manutenção, mediante aprovação do proprietário.</li>
		<li>• Suporte completo dos processos de renovação e rescisão do contrato de locação.</li>
	</ul>

	<p>
		A Freire Imóveis é reconhecida pela satisfação dos clientes, conquistada pelo bom atendimento e pela rapidez em alugar. Com os menores índices de inadimplência do mercado, resultado da avaliação criteriosa do cadastro de locadores e fiadores, a Freire Imóveis reafirma o compromisso em oferecer sempre o melhor para inquilinos e proprietários.
	</p>
	<p>
		Para conhecer mais vantagens e deixar o seu imóvel para alugar com a Freire Imóveis, envie o seu imóvel (clique aqui) e aguarde o contato de um de nossos atendentes.
	</p>

	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>

</div>